import { requestApi } from "./axiosHelper"

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1"

const stageEp = rootUrl + "/stage"

const stageApi = {
  addAStage: async (obj) => {
    console.log(obj)
    try {
      const axiosData = {
        url: stageEp,
        method: "post",
        data: obj,
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },
}

export default stageApi
